import type { ReactNode } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

export const QUICK_START_PATH = '/flows/quick-start';

/**
 * Ancien lien profond /flows?quickstart=open (favoris, anciens e-mails) : mène au
 * démarrage rapide, avant même de monter la liste des flows.
 */
export default function QuickStartLinkGate({ children }: { children: ReactNode }) {
    const [searchParams] = useSearchParams();

    if (searchParams.get('quickstart') === 'open') {
        return <Navigate to={QUICK_START_PATH} replace />;
    }

    return <>{children}</>;
}
